import { useState, useEffect, useContext, useReducer } from "react";
import { getAdminUsers } from "../../utils/actions/allactions";
import Sidebar from "../Sidebar";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import moment from "moment";
import Pagination from "react-paginate";
import waitingImage from "../../images/waiting.svg";
import tickGreenImage from "../../images/tick-green.svg";
import settingImage from "../../images/setting-green.svg";
import cancelledImage from "../../images/close_red.svg";
import HoverInfo from "../../components/HoverInfo/HoverInfo";
import { ADMIN_ACTIONS, useAdminContext } from "../../context/admin.context";
import { Modal as AntModal } from "antd";
import {
  changeRFQAdminOwner,
  fetchFilteredRFQs,
  fetchRfqForProjectNameSearch,
} from "../../utils/actions/supplierActions";
import ChatButton from "../../Chat/ChatButton";
import Chat from "../../Chat";
import { ChatRefContext } from "../../context/chatRef.context";
import { currencyFormatter, validateAdmin } from "../../utils/helper";
import { Form } from "react-bootstrap";
import useDocumentTitle from "../../utils/useDocumentTitle";
import { Loading } from "../../components/Loading";
import allValuesImage from "../../images/all-entity.svg";
import { fetchQuotationDataForRFQ } from "../../utils/actions/adminActions";
import { GenericSearchComponent } from "../../components/GenericFiltersComponents";
import { debounceConstant } from "../../utils/constant";
import GenericLoaderComponent from "../Loading/GenericLoaderComponent";

const RFQs = () => {
  const navigate = useNavigate();
  const location = useLocation();
  useDocumentTitle("RFQs");
  const [allRFQs, setAllRFQs] = useState([]);

  const { state, dispatch } = useAdminContext();
  const { setSelectedChatRefId, selectedChatRefId, setChatType, chatType } =
    useContext(ChatRefContext);
  const [adminUsers, setAdminUsers] = useState([]);
  const [directFilterVal, setDirectFilterVal] = useState("");
  const [directRFQResult, setDirectRFQResult] = useState([]);
  const [loading, setLoading] = useState(false);
  let token = localStorage.getItem("Token");
  const [isLoadingRefData, setIsLoadingRefData] = useState(false);


  const buildQueryForSearch = (type, query) => {
    console.log("Fired");
    const isFalsy = (value) => value == 'undefined' || value == 'null' || value === undefined || value === null || value === false || value === 0 || value === "" || Number.isNaN(value);
    const currentParams = new URLSearchParams(location.search);
    if (type == 'owner') {
      currentParams.set('owner', query);
    }
    else if (type == 'rfqOfferId') {
      currentParams.set('rfqOfferId', query);
    }
    else if (type == 'createdFrom') {
      currentParams.set("createdFrom", query);
    }
    else if (type == 'createdTo') {
      currentParams.set("createdTo", query);
    }
    else if (type == 'sorting') {
      const [field, sortOrder] = query?.split(":");
      currentParams.set("sortField", field);
      currentParams.set("sortOrder", sortOrder);
    }
    else {
      currentParams.set(type, query);
    }


    //remove empty values
    for (const [key, value] of currentParams) {
      if (isFalsy(value)) {
        currentParams.delete(key);
      }
    };
    const newQuery = currentParams.toString();
    navigate(`?${newQuery}`);
  }

  const initialQuoteState = {
    createdFrom: "",
    createdTo: "",
    userName: "",
    adminOwnerId: "",
    sortBy: "createdAt",
    sortOrder: 1,
    pageNum: 1,
    totalPages: 0,
    quoteList: [],
    quotationCount: {},
  };

  const QUOTE_ACTIONS = {
    UPDATE_CREATED_FROM: "update-created-from",
    UPDATE_CREATED_TO: "update-created-to",
    UPDATE_USER_NAME: "update-user-name",
    UPDATE_ADMIN_OWNER_ID: "update-owner-id",
    UPDATE_SORT_BY: "update-sort-by",
    UPDATE_SORT_ORDER: "update-sort-order",
    UPDATE_PAGE_NUM: "update-page-num",
    UPDATE_TOTAL_PAGE: "update-total-page",
    UPDATE_QUOTE_LIST: "update-quotes",
    UPDATE_QUOTE_COUNT: "update-quote-count",
    UPDATE_QUOTE_FILTER: "update-quote-filter",
  };

  const quotationReducer = (state, action) => {
    switch (action.type) {
      case QUOTE_ACTIONS.UPDATE_CREATED_FROM:
        return { ...state, createdFrom: action.payload };
      case QUOTE_ACTIONS.UPDATE_CREATED_TO:
        return { ...state, createdTo: action.payload };
      case QUOTE_ACTIONS.UPDATE_USER_NAME:
        return { ...state, userName: action.payload };
      case QUOTE_ACTIONS.UPDATE_ADMIN_OWNER_ID:
        return { ...state, adminOwnerId: action.payload };
      case QUOTE_ACTIONS.UPDATE_SORT_BY:
        return { ...state, sortBy: action.payload };
      case QUOTE_ACTIONS.UPDATE_SORT_ORDER:
        return { ...state, sortOrder: action.payload };
      case QUOTE_ACTIONS.UPDATE_PAGE_NUM:
        return { ...state, pageNum: action.payload };
      case QUOTE_ACTIONS.UPDATE_TOTAL_PAGE:
        return { ...state, totalPages: action.payload };
      case QUOTE_ACTIONS.UPDATE_QUOTE_LIST:
        return { ...state, quoteList: action.payload };
      case QUOTE_ACTIONS.UPDATE_QUOTE_COUNT:
        return { ...state, quotationCount: action.payload };
      case QUOTE_ACTIONS.UPDATE_QUOTE_FILTER:
        return { ...state, ...action.payload };
      default:
        return state;
    }
  };

  const [quotationState, quotationDispatch] = useReducer(
    quotationReducer,
    initialQuoteState
  );

  useEffect(() => {
    validateAdmin(token, navigate);
    if (token) {
      async function fetchAdminUser() {
        try {
          let response = await getAdminUsers(token);
          setAdminUsers(response);
        } catch (error) {
          toast.error(error);
        }
      }
      fetchAdminUser();
    }
  }, []);
  useEffect(() => {
    if (Array.isArray(quotationState?.quoteList) && quotationState?.quoteList.length) {
      const params = new URLSearchParams(location.search);
      if (params.has('owner')) {
        const val = params.get('owner');

        quotationDispatch({
          type: QUOTE_ACTIONS.UPDATE_ADMIN_OWNER_ID,
          payload: val,
        });
      }
      if (params.has('rfqOfferId')) {
        const val = params.get('rfqOfferId');
        handleRFQSearch(val);
      }
      if (params.has('createdFrom')) {
        const val = params.get('createdFrom');
        quotationDispatch({
          type: QUOTE_ACTIONS.UPDATE_CREATED_FROM,
          payload: val,
        });
      }
      if (params.has('createdTo')) {
        const val = params.get('createdTo');

        quotationDispatch({
          type: QUOTE_ACTIONS.UPDATE_CREATED_TO,
          payload: val,
        });
      }
      if (params.get('bucket')) {
        const field = params.get('bucket');
        dispatch({
          type: ADMIN_ACTIONS.UPDATE_RFQ_ACTIVE_FILTER,
          payload: field,
        });
      }
      if (params.get("sortField") && params.get("sortOrder")) {
        const field = params.get("sortField");
        const sortStatus = Number(params.get("sortOrder"));
        quotationDispatch({
          type: QUOTE_ACTIONS.UPDATE_SORT_BY,
          payload: field,
        });
        quotationDispatch({
          type: QUOTE_ACTIONS.UPDATE_SORT_ORDER,
          payload: sortStatus,
        });
      }
    }

  }, [location.search
    , quotationState.quoteList,
  ]);

  useEffect(() => {
    // handleSubmit();
    const fetchData = async () => {
      try {
        setLoading(true);
        let data = {
          createdFrom: quotationState.createdFrom,
          createdTo: quotationState.createdTo,
          userName: quotationState.userName,
          adminOwnerId: quotationState.adminOwnerId,
          sortBy: quotationState.sortBy,
          sortOrder: quotationState.sortOrder,
          pageNum: quotationState.pageNum,
          quotationFilter: state.rfqActiveFilter,
        };
        const response = await fetchFilteredRFQs(token, data);
        let quotationIdArr = [];
        response.data.quotations.forEach((item) =>
          quotationIdArr.push(item.quotationId)
        );

        const quotationDataResponse = await fetchQuotationDataForRFQ(
          token,
          quotationIdArr
        );

        if (quotationDataResponse.status) {
          response.data.quotations.forEach((rfqItem) => {
            let attachedQuotation = quotationDataResponse.data.filter(
              (quotationItem) => quotationItem._id === rfqItem.quotationId
            )[0];
            if (attachedQuotation) {
              rfqItem.quotationId = attachedQuotation;
            }
            // })
          });
        }

        quotationDispatch({
          type: QUOTE_ACTIONS.UPDATE_QUOTE_LIST,
          payload: response?.data?.quotations,
        });
        let quotationBucketCount = response?.data?.quoteCategoryCount;
        quotationDispatch({
          type: QUOTE_ACTIONS.UPDATE_QUOTE_COUNT,
          payload: quotationBucketCount,
        });
        let totalPages = response?.data?.totalPages;

        quotationDispatch({
          type: QUOTE_ACTIONS.UPDATE_TOTAL_PAGE,
          payload: totalPages || 0,
        });
        setLoading(false);

      } catch (err) {
        setLoading(false);
        console.log("err", err);
      }
    };
    console.log(quotationState, "::::::::::::::::::")

    fetchData();
  }, [
    quotationState.createdFrom,
    quotationState.createdTo,
    quotationState.userName,
    quotationState.adminOwnerId,
    quotationState.sortBy,
    quotationState.sortOrder,
    quotationState.pageNum,
    state.rfqActiveFilter,
  ]);

  const showDrawer = (id) => {
    setSelectedChatRefId(id);
    setChatType("supplier");
  };

  const onClose = () => {
    setChatType(null);
    setSelectedChatRefId(null);
  };



  const handleAdminOwnerChange = async (e, rfqOfferId) => {
    try {
      let adminUserSelected = adminUsers.filter(
        (item) => item._id == e.target.value
      )[0];
      let adminResponse = await new Promise((resolve) => {
        AntModal.confirm({
          title: 'Assign Quotation',
          content: `Are you sure you want to assign this quotation to ${adminUserSelected.firstName} ${adminUserSelected.lastName || ''}?`,
          okText: 'Yes',
          cancelText: 'No',
          onOk: () => resolve(true),
          onCancel: () => resolve(false),
        });
      });
      if (!adminResponse) {
        return;
      }
      let data = {
        rfqOfferId: rfqOfferId,
        adminId: adminUserSelected?._id,
      };
      let rfqResponse = await changeRFQAdminOwner(token, data);
      if (rfqResponse.status) {
        let localQuotationList = [...quotationState.quoteList];
        localQuotationList.forEach((item) => {
          if (item._id == rfqOfferId) {
            item.adminOwnerId = adminUserSelected._id;
          }
        });
        quotationDispatch({
          type: QUOTE_ACTIONS.UPDATE_QUOTE_LIST,
          payload: localQuotationList,
        });

        fetchData();
        toast.success("Admin owner changed successfully.");
      }
    } catch (err) {
      console.log(
        "Error in 86 Quotes on " +
        moment(Date.now()).format("DD MMM YYYY hh:mm:ss a"),
        err
      );
    }
  };

  let handleActivePage = async (value) => {
    let pageNum = value?.selected + 1 || 1;
    quotationDispatch({
      type: QUOTE_ACTIONS.UPDATE_PAGE_NUM,
      payload: pageNum,
    });
  };

  const handleBucketFilterClick = (field) => {
    dispatch({
      type: ADMIN_ACTIONS.UPDATE_RFQ_ACTIVE_FILTER,
      payload: field,
    });
    buildQueryForSearch('bucket', field);

    quotationDispatch({
      type: QUOTE_ACTIONS.UPDATE_QUOTE_FILTER,
      payload: {
        createdFrom: "",
        createdTo: "",
        userName: "",
        adminOwnerId: "",
        sortBy: "",
        sortOrder: 1,
        pageNum: 1,
        totalPages: 0,
      },
    });
  };

  let handleRefresh = () => {
    dispatch({
      type: ADMIN_ACTIONS.UPDATE_RFQ_ACTIVE_FILTER,
      payload: "all-rfq",
    });
    quotationDispatch({
      type: QUOTE_ACTIONS.UPDATE_QUOTE_FILTER,
      payload: {
        createdFrom: "",
        createdTo: "",
        userName: "",
        adminOwnerId: "",
        sortBy: "createdAt",
        sortOrder: -1,
        pageNum: 1,
        totalPages: 0,
      },
    });
    navigate("?");
  };

  let handleSort = (field) => {
    quotationDispatch({
      type: QUOTE_ACTIONS.UPDATE_SORT_BY,
      payload: field,
    });
    let sortStatus = quotationState.sortBy == field ? quotationState.sortOrder == 1 ? -1 : 1 : 1;
    console.log("status ::", sortStatus);
    console.log("Quote state ::", quotationState);

    quotationDispatch({
      type: QUOTE_ACTIONS.UPDATE_SORT_ORDER,
      payload: sortStatus,
    });
    buildQueryForSearch('sorting', `${field}:${sortStatus}`);
  };

  useEffect(() => {

    const t = setTimeout(async () => {
      console.log("Value is ::", directFilterVal);

      try {
        buildQueryForSearch("refId", directFilterVal);

        if (!directFilterVal) {
          setDirectRFQResult([]);
          return;
        }

        const response = await fetchRfqForProjectNameSearch(token, directFilterVal);
        if (response.status) {
          setDirectRFQResult(response.data);
        } else {
          setDirectRFQResult([]);
          toast.error("Something went wrong while fetching the data.");
        }
      } catch (err) {
        console.log("error in handleQuoteSerach", err);
      } finally {
        setIsLoadingRefData(false);
      }
    }, debounceConstant);
    return () => clearTimeout(t);
  }, [directFilterVal, token]);

  const handleRFQSearch = async (value) => {
    setDirectFilterVal(value);
    setIsLoadingRefData(!!value);
  };
  const filterConfigs = [
    {
      options: adminUsers,
      showValue: (val) => val.firstName + " " + (val.lastName || ""),
      onChange: (selectedValue) => {

        quotationDispatch({
          type: QUOTE_ACTIONS.UPDATE_ADMIN_OWNER_ID,
          payload: selectedValue,
        });
        buildQueryForSearch('owner', selectedValue);
      },
      value: quotationState?.adminOwnerId,
      type: 'select',
      placeholder: 'Search owner',
      defaultValue: 'Select owner',
      getValue: (o) => o?._id,
      label: 'Admin owner'
    },
    {
      type: "search & dropdown",
      title: "Ref ID",
      dropdownClassName: '!w-[500px]',
      onSearch: handleRFQSearch,
      DropDownComponent: () => {
        if (directRFQResult.length == 0) return <div className="text-center text-sm font-medium">No results found</div>;
        return <div className="overflow-x-auto">
          <table className="w-full border-collapse border border-gray-300 bg-white shadow-sm rounded-lg">
            <thead className="bg-primaryColor">
              <tr>
                <th className="border border-gray-300 px-2 py-2 text-left text-xs font-semibold text-white">
                  Project Name
                </th>
                <th className="border border-gray-300 px-2 py-2 text-left text-xs font-semibold text-white">
                  Created Date
                </th>
                <th className="border border-gray-300 px-2 py-2 text-left text-xs font-semibold text-white">
                  Status
                </th>
              </tr>
            </thead>
            <tbody>
              {directRFQResult.length > 0 &&
                directRFQResult?.map((val, i) => {
                  console.log("Val ::", val);
                  return (
                    <tr
                      key={i}
                      className="direct-search-drop-down hover:bg-primaryColor hover:text-white cursor-pointer transition-colors duration-150 group"
                      onClick={() =>
                        window.open(
                          `/admin/rfq-details/${val?._id}`,
                          "_blank"
                        )
                      }
                    >
                      <td className="border  border-gray-300 px-2 py-1 text-xs text-gray-800 group-hover:text-white text-left w-max">
                        {val?.projectName}
                      </td>
                      <td className="border border-gray-300 px-2 py-1 text-xs text-gray-800 group-hover:text-white">
                        {moment(val.createdAt).format(
                          "DD MMM YYYY"
                        )}
                      </td>
                      <td className="border border-gray-300 px-2 py-1 text-xs text-gray-800 group-hover:text-white">
                        {val.rfqOfferStatus}
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
          ;
      },
      label: 'Ref ID',
      isDropdown: !!directFilterVal,
      isLoadingOn: isLoadingRefData,
    },
    {
      type: "date",
      mode: "single",
      placeholder: 'Created From',
      value: quotationState.createdFrom ? moment(quotationState.createdFrom) : null,
      // format: "DD-MM-YYYY",
      onChange: (date, dateString) => {

        if (dateString) {
          quotationDispatch({
            type: QUOTE_ACTIONS.UPDATE_CREATED_FROM,
            payload: dateString,
          });
          buildQueryForSearch("createdFrom", dateString);
        } else {
          quotationDispatch({
            type: QUOTE_ACTIONS.UPDATE_CREATED_FROM,
            payload: null,
          });
          buildQueryForSearch("createdFrom", null);
        }
      },
      label: 'Created From'
    },

    {
      type: "date",
      mode: "single",
      placeholder: 'Created To',
      value: quotationState.createdTo ? moment(quotationState.createdTo) : null,
      // format: "DD-MM-YYYY",
      onChange: (date, dateString) => {

        if (dateString) {
          quotationDispatch({
            type: QUOTE_ACTIONS.UPDATE_CREATED_TO,
            payload: dateString,
          });
          buildQueryForSearch("createdTo", dateString);
        } else {
          quotationDispatch({
            type: QUOTE_ACTIONS.UPDATE_CREATED_TO,
            payload: null,
          });
          buildQueryForSearch("createdTo", null);
        }
      },
      label: 'Created To'

    },
    {
      onClick: handleRefresh,
      buttonText: 'Reset all filters',
      type: "button",
    }
  ]

  return (
    <div
      className="admin-container"
      style={{
        width: "100%",
        overflowX: "auto",
        backgroundColor: "#f4e6dd",
        minHeight: "100vh",
      }}
    >
      <Sidebar />
      {/* <div style={{ height: "auto" }}>{loading ? <Loading /> : ""}</div> */}
      <GenericLoaderComponent
        isLoading={loading}
      />
      <span style={{ width: "100%" }}>
        <div className="center-heading">
          <h1 className="text-2xl font-bold mt-3">Offers & RFQs</h1>
          <div className="right-container ">
            <div className="bucketFilterDiv">
              <div
                className={`bucketFilterOptions ${state.rfqActiveFilter == "all-rfq" ? "selected" : ""
                  }`}
                onClick={() => handleBucketFilterClick("all-rfq")}
              >
                <span className="textBox">
                  <p>All RFQ & Offers</p>
                  <h5>{quotationState?.quotationCount?.allCount}</h5>
                </span>
                <img className="filterIcon" src={allValuesImage} />
              </div>

              <div
                className={`bucketFilterOptions ${state.rfqActiveFilter == "active-rfq" ? "selected" : ""
                  }`}
                onClick={() => handleBucketFilterClick("active-rfq")}
              >
                <span className="textBox">
                  <p>Active RFQ & Offers</p>
                  <h5>{quotationState?.quotationCount?.activeCount || 0}</h5>
                </span>
                <img className="filterIcon" src={waitingImage} />
              </div>

              <div
                className={`bucketFilterOptions ${state.rfqActiveFilter == "progress" ? "selected" : ""
                  }`}
                onClick={() => handleBucketFilterClick("progress")}
              >
                <span className="textBox">
                  <p>In Progress RFQ & Offers </p>
                  <h5>{quotationState?.quotationCount?.progressCount || 0}</h5>
                </span>
                <img className="filterIcon" src={settingImage} />
              </div>

              <div
                className={`bucketFilterOptions ${state.rfqActiveFilter == "completed" ? "selected" : ""
                  }`}
                onClick={() => handleBucketFilterClick("completed")}
              >
                <span className="textBox">
                  <p>Completed RFQ & Offers</p>
                  <h5>{quotationState?.quotationCount?.completeCount || 0}</h5>
                </span>
                <img className="filterIcon" src={tickGreenImage} />
              </div>

              {/* <div
                className={`bucketFilterOptions ${state.rfqActiveFilter == "cancelled" ? "selected" : ""
                  }`}
                onClick={() => handleBucketFilterClick("cancelled")}
              >
                <span className="textBox">
                  <p>Cancelled RFQ</p>
                  <h5>{quotationState?.quotationCount?.cancelledCount || 0}</h5>
                </span>
                <img className="filterIcon" src={cancelledImage} />
              </div> */}
              <div
                className={`bucketFilterOptions ${state.rfqActiveFilter == "cancelled-offer" ? "selected" : ""
                  }`}
                onClick={() => handleBucketFilterClick("cancelled-offer")}
              >
                <span className="textBox">
                  <p>Declined offers</p>
                  <h5>{quotationState?.quotationCount?.cancelledofferCount || 0}</h5>
                </span>
                <img className="filterIcon" src={cancelledImage} />
              </div>
            </div>
            {/* <div className="bucketFilterDiv">
              <div
                className={`bucketFilterOptions ${state.rfqActiveFilter == "all-offer" ? "selected" : ""
                  }`}
                onClick={() => handleBucketFilterClick("all-offer")}
              >
                <span className="textBox">
                  <p>All Offers</p>
                  <h5>{quotationState?.quotationCount?.allCount}</h5>
                </span>
                <img className="filterIcon" src={allValuesImage} />
              </div>

              <div
                className={`bucketFilterOptions ${state.rfqActiveFilter == "active-offer" ? "selected" : ""
                  }`}
                onClick={() => handleBucketFilterClick("active-offer")}
              >
                <span className="textBox">
                  <p>Active Offers</p>
                  <h5>{quotationState?.quotationCount?.activeCount || 0}</h5>
                </span>
                <img className="filterIcon" src={waitingImage} />
              </div>

              <div
                className={`bucketFilterOptions ${state.rfqActiveFilter == "progress-offer" ? "selected" : ""
                  }`}
                onClick={() => handleBucketFilterClick("progress-offer")}
              >
                <span className="textBox">
                  <p>In Progress Offers</p>
                  <h5>{quotationState?.quotationCount?.progressCount || 0}</h5>
                </span>
                <img className="filterIcon" src={settingImage} />
              </div>

              <div
                className={`bucketFilterOptions ${state.rfqActiveFilter == "completed-offer" ? "selected" : ""
                  }`}
                onClick={() => handleBucketFilterClick("completed-offer")}
              >
                <span className="textBox">
                  <p>Completed Offers</p>
                  <h5>{quotationState?.quotationCount?.completeCount || 0}</h5>
                </span>
                <img className="filterIcon" src={tickGreenImage} />
              </div>

              <div
                className={`bucketFilterOptions ${state.rfqActiveFilter == "cancelled-offer" ? "selected" : ""
                  }`}
                onClick={() => handleBucketFilterClick("cancelled-offer")}
              >
                <span className="textBox">
                  <p>Cancelled Offers</p>
                  <h5>{quotationState?.quotationCount?.cancelledCount || 0}</h5>
                </span>
                <img className="filterIcon" src={cancelledImage} />
              </div>
            </div> */}
            <div className="search-bar">
              <div
                className="row"
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "flex-start",
                }}
              >
                <GenericSearchComponent
                  config={filterConfigs}
                  parentClassName={'filters grid md:grid-cols-3  xl:grid-cols-4 gap-2 '}
                />
                {/* <div className="search-block">
                  <label className="sr-label">Admin Owner</label>
                  <Form.Select
                    aria-label="Default select example"
                    value={quotationState?.adminOwnerId || "default"}
                    style={{ width: "100%" }}
                    onChange={(e) => {
                      dispatch({
                        type: ADMIN_ACTIONS.UPDATE_RFQ_ACTIVE_FILTER,
                        payload: "all-rfq",
                      });
                      quotationDispatch({
                        type: QUOTE_ACTIONS.UPDATE_ADMIN_OWNER_ID,
                        payload: e.target.value,
                      });
                      buildQueryForSearch('owner', e.target.value);
                    }}
                  >
                    <option value="default" disabled>
                      {" "}
                      Select owner
                    </option>
                    {adminUsers.map((val, i) => {
                      return (
                        <option key={i} value={val._id}>
                          {val.firstName + " " + val.lastName || ""}
                        </option>
                      );
                    })}
                  </Form.Select>
                </div>

                <div className="search-block">
                  <label className="sr-label">Ref ID</label>
                  <input
                    type="text"
                    className="form-control"
                    value={directFilterVal}
                    placeholder="Search Ref ID"
                    onChange={handleRFQSearch}
                  />
                  {directFilterVal?.trim()?.length > 0 &&
                    directRFQResult.length > 0 ? (
                    <div className="direct-search-drop-down-div ">
                      <table className="search-table">
                        <thead>
                          <tr>
                            <th>Project Name</th>
                            <th>Created Date</th>
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {directRFQResult.length > 0 &&
                            directRFQResult?.map((val, i) => {
                              return (
                                <tr
                                  key={i}
                                  className="direct-search-drop-down"
                                  onClick={() =>
                                    window.open(
                                      `/admin/rfq-details/${val?._id}`,
                                      "_blank"
                                    )
                                  }
                                >
                                  <td style={{ textAlign: "left" }}>
                                    {val?.projectName}
                                  </td>
                                  <td>
                                    {moment(val.createdAt).format(
                                      "DD MMM YYYY"
                                    )}
                                  </td>
                                  <td>{val.rfqOfferStatus}</td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <></>
                  )}
                </div>

                <div className="search-block">
                  <label className="sr-label"> Created From</label>
                  <input
                    type="date"
                    value={quotationState.createdFrom}
                    className="form-control"
                    onChange={(e) => {
                      dispatch({
                        type: ADMIN_ACTIONS.UPDATE_RFQ_ACTIVE_FILTER,
                        payload: "all-rfq",
                      });
                      quotationDispatch({
                        type: QUOTE_ACTIONS.UPDATE_CREATED_FROM,
                        payload: e.target.value,
                      });
                      buildQueryForSearch('createdFrom', e.target.value);
                    }}
                  />
                </div>
                <div className="search-block">
                  <label className="sr-label"> Created To</label>
                  <input
                    type="date"
                    value={quotationState.createdTo}
                    className="form-control"
                    onChange={(e) => {
                      dispatch({
                        type: ADMIN_ACTIONS.UPDATE_RFQ_ACTIVE_FILTER,
                        payload: "all-rfq",
                      });
                      quotationDispatch({
                        type: QUOTE_ACTIONS.UPDATE_CREATED_TO,
                        payload: e.target.value,
                      });
                      buildQueryForSearch('createdTo', e.target.value);
                    }}
                  />
                </div> */}

                {/* <div className="search-btn" style={{ marginTop: "10px" }}>
                  <button onClick={handleRefresh} className="button-search">
                    Reset all filters
                  </button>
                </div> */}
              </div>
            </div>
            <Chat
              RefId={selectedChatRefId}
              open={selectedChatRefId?.length > 0}
              onDrawerClose={onClose}
            />
            <div className="quotes-table">
              <table className="table">
                <thead>
                  <tr>
                    <th
                      scope="col"
                      style={{ cursor: "pointer" }}
                      onClick={() => handleSort("projectName")}
                    >
                      Project Name{" "}
                      {quotationState.sortBy == "projectName"
                        ? quotationState.sortOrder == 1
                          ? "↓"
                          : "↑"
                        : "↓"}
                    </th>
                    <th scope="col" style={{ cursor: "pointer" }}>
                      {" "}
                      Admin Owner{" "}
                    </th>
                    <th scope="col" style={{ cursor: "pointer" }}>
                      (Quote)Created At{" "}
                    </th>
                    <th scope="col" style={{ cursor: "pointer" }}>
                      Days(Quote)
                    </th>
                    <th
                      scope="col"
                      style={{ cursor: "pointer" }}
                      onClick={() => handleSort("createdAt")}
                    >
                      (RFQ)Created At{" "}
                      {quotationState.sortBy == "createdAt"
                        ? quotationState.sortOrder == 1
                          ? "↓"
                          : "↑"
                        : "↓"}
                    </th>
                    <th scope="col" style={{ cursor: "pointer" }}>
                      Days(RFQ){" "}
                    </th>
                    <th scope="col" style={{ cursor: "pointer" }}>
                      Rapid
                    </th>
                    <th scope="col" style={{ cursor: "pointer" }}>
                      Standard{" "}
                    </th>
                    <th scope="col" style={{ cursor: "pointer" }}>
                      Economy
                    </th>
                    {/* <th scope="col">Action</th> */}
                  </tr>
                </thead>
                <tbody>
                  {quotationState.quoteList?.length > 0 &&
                    quotationState.quoteList?.map((item, index) => {
                      console.log("Item ::", item);
                      return (
                        <tr key={index} style={{ backgroundColor: "#fff" }}>
                          <td
                          >
                            <div className="flex justify-start items-center gap-x-2  ">
                              <Link
                                to={
                                  item.projectName.split("")[0] == "O" && item.type == "offer"
                                    ? `/admin/offers-details/${item?._id}`
                                    : `/admin/rfq-details/${item?._id}`

                                }
                                className="text-primaryColor"
                              >
                                {item.projectName ? item.projectName : "Project name not available"}
                              </Link>{" "}

                              <HoverInfo content={item.adminComment} />
                            </div>
                            {state.rfqActiveFilter == "all-rfq" &&
                              item?.rfqOfferStatus ? (
                              <div className="ms-2">
                                <br />
                                {`(${item?.rfqOfferStatus})`}
                              </div>
                            ) : (
                              ""
                            )}
                          </td>
                          <td>
                            <Form.Select
                              aria-label="Default select example"
                              value={item?.adminOwnerId || "default"}
                              style={{ width: "100%", marginTop: "-10px" }}
                              onChange={(e) => {
                                handleAdminOwnerChange(e, item._id);
                              }}
                            >
                              <option value="default" disabled>
                                {" "}
                                Select owner
                              </option>
                              {adminUsers.map((val, i) => {
                                return (
                                  <option key={i} value={val._id}>
                                    {val.firstName + " " + val.lastName || ""}
                                  </option>
                                );
                              })}
                            </Form.Select>
                          </td>
                          <td>
                            {moment(item?.quotationId?.createdAt).format(
                              "MMM DD, YYYY"
                            )}
                          </td>
                          <td>
                            {Math.abs(
                              moment(item?.quotationId?.createdAt).diff(
                                Date.now(),
                                "days"
                              )
                            )}
                          </td>
                          <td>
                            {moment(item.createdAt).format("MMM DD, YYYY")}
                          </td>

                          <td>
                            {Math.abs(
                              moment(item?.createdAt).diff(Date.now(), "days")
                            )}
                          </td>
                          <td>
                            <span>
                              {item?.supplierRFQData?.length >= 1 ? (
                                <>
                                  {item?.supplierRFQData[0]?.isDeclined ? (
                                    <>
                                      <span
                                        style={{
                                          color: "red",
                                          fontWeight: "bolder",
                                        }}
                                      >
                                        Declined
                                      </span>
                                      <br />
                                    </>
                                  ) : (
                                    <>
                                      <span>
                                        {currencyFormatter(
                                          Number(
                                            item.supplierRFQData[0].price
                                          ).toFixed(2)
                                        )}
                                      </span>
                                      <br />
                                      <span>{`${item.supplierRFQData[0]?.leadTime
                                        }D (${Math.floor(
                                          item.supplierRFQData[0]?.leadTime / 7
                                        )}-${Math.floor(
                                          item.supplierRFQData[0]?.leadTime / 7
                                        ) + 1
                                        } weeks)`}</span>
                                      <br />
                                    </>
                                  )}

                                  <span className="whitespace-nowrap">
                                    {
                                      item.supplierRFQData[0]?.supplierId
                                        ?.supplierRefId
                                    }{" "}
                                    - (
                                    {
                                      item.supplierRFQData[0]?.supplierId
                                        ?.address?.country
                                    }
                                    )
                                  </span>
                                  <br />
                                  <span
                                    onClick={() =>
                                      showDrawer(
                                        item.supplierRFQData[0]
                                          ?.supplierRFQRefId
                                      )
                                    }
                                    type="button"
                                    className="up-button bg-primaryColor h-7 mt-2"
                                  >
                                    <ChatButton
                                      RefId={
                                        item.supplierRFQData[0]
                                          ?.supplierRFQRefId
                                      }
                                      textClasses={'text-sm whitespace-nowrap'}
                                      showDrawer={showDrawer}
                                    />
                                  </span>
                                </>
                              ) : (
                                <>
                                  <p>NA</p>
                                </>
                              )}
                            </span>
                          </td>
                          <td>
                            <span>
                              {item?.supplierRFQData?.length >= 2 ? (
                                <>
                                  {item.supplierRFQData[1].isDeclined ? (
                                    <>
                                      <span
                                        style={{
                                          color: "red",
                                          fontWeight: "bolder",
                                        }}
                                      >
                                        Declined
                                      </span>
                                      <br />
                                    </>
                                  ) : (
                                    <>
                                      <span>
                                        {currencyFormatter(
                                          Number(
                                            item.supplierRFQData[1].price
                                          ).toFixed(2)
                                        )}
                                      </span>
                                      <br />
                                      <span>{`${item.supplierRFQData[1]?.leadTime
                                        }D (${Math.floor(
                                          item.supplierRFQData[1]?.leadTime / 7
                                        )}-${Math.floor(
                                          item.supplierRFQData[1]?.leadTime / 7
                                        ) + 1
                                        } weeks)`}</span>
                                      <br />
                                    </>
                                  )}

                                  <span className="whitespace-nowrap">
                                    {
                                      item.supplierRFQData[1]?.supplierId
                                        ?.supplierRefId
                                    }{" "}
                                    - (
                                    {
                                      item.supplierRFQData[1]?.supplierId
                                        ?.address?.country
                                    }
                                    )
                                  </span>
                                  <br />
                                  <span
                                    onClick={() =>
                                      showDrawer(
                                        item.supplierRFQData[1]
                                          ?.supplierRFQRefId
                                      )
                                    }
                                    type="button"
                                    // className="up-button"
                                    // style={{
                                    //   marginTop: "3px 0px",
                                    //   textAlign: "center",
                                    //   background: "white",
                                    //   color: "#2B96DC",
                                    //   width: "100px",
                                    //   border: "1px solid #a8e5ff",
                                    // }}
                                    className="up-button bg-primaryColor h-7 mt-2"
                                  >
                                    <ChatButton
                                      RefId={
                                        item.supplierRFQData[1]
                                          ?.supplierRFQRefId
                                      }
                                      showDrawer={showDrawer}
                                    />
                                  </span>
                                </>
                              ) : (
                                <>
                                  <p>NA</p>
                                </>
                              )}
                            </span>
                          </td>
                          <td>
                            <span>
                              {item?.supplierRFQData?.length >= 3 ? (
                                <>
                                  {item.supplierRFQData[2].isDeclined ? (
                                    <>
                                      <span
                                        style={{
                                          color: "red",
                                          fontWeight: "bolder",
                                        }}
                                      >
                                        Declined
                                      </span>
                                      <br />
                                    </>
                                  ) : (
                                    <>
                                      <span>
                                        {currencyFormatter(
                                          Number(
                                            item.supplierRFQData[2].price
                                          ).toFixed(2)
                                        )}
                                      </span>
                                      <br />
                                      <span className="!text-[12px]">{`${item.supplierRFQData[2]?.leadTime
                                        }D (${Math.floor(
                                          item.supplierRFQData[2]?.leadTime / 7
                                        )}-${Math.floor(
                                          item.supplierRFQData[2]?.leadTime / 7
                                        ) + 1
                                        } weeks)`}</span>
                                      <br />
                                    </>
                                  )}

                                  <span>
                                    {
                                      item.supplierRFQData[2]?.supplierId
                                        ?.supplierRefId
                                    }{" "}
                                    - (
                                    {
                                      item.supplierRFQData[2]?.supplierId
                                        ?.address?.country
                                    }
                                    )
                                  </span>
                                  <br />
                                  <span
                                    onClick={() =>
                                      showDrawer(
                                        item.supplierRFQData[2]
                                          ?.supplierRFQRefId
                                      )
                                    }
                                    type="button"
                                    className="up-button bg-primaryColor h-7 mt-2  "


                                  >
                                    <ChatButton
                                      RefId={
                                        item.supplierRFQData[2]
                                          ?.supplierRFQRefId
                                      }
                                      showDrawer={showDrawer}
                                    />
                                  </span>
                                </>
                              ) : (
                                <>
                                  <p>NA</p>
                                </>
                              )}
                            </span>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
            <div className="floatRight">
              <Pagination
                key={state.rfqActiveFilter}
                previousLabel="<"
                nextLabel=">"
                breakLabel="..."
                pageCount={quotationState?.totalPages}
                marginPagesDisplayed={2}
                pageRangeDisplayed={2}
                onPageChange={handleActivePage}
                containerClassName="pagination"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                previousLinkClassName="page-link"
                breakClassName="page-item"
                breakLinkClassName="page-link"
                activeClassName="active"
              />
            </div>
          </div>
        </div>
      </span>
    </div>
  );
};

export default RFQs;
